import get from 'lodash/get';
import {getRootStore} from '../../app.bootstrap';
import {IRouteStore} from '../../router/routing.infra';
import {IUrlParams} from '../../services/RedirectionService';
import {IAppUser} from '../../app.state';
import {HistoryConsoleController, DEFAULT_DATE_FORMAT} from './controller';
import {MainLayoutController, IMainLayoutController} from '../../layouts/main-layout/layout.controller';
import {HistoryConsoleLeftBarController} from './history-console-left-bar.controller';
import {GeneralSettings} from '../../models/AccountSettings';

export interface IHistoryConsoleStore extends IRouteStore {
    historyConsoleController: HistoryConsoleController;
    mainLayoutController: IMainLayoutController;
    leftBarController: HistoryConsoleLeftBarController;
    agentSettingsController: any;
    inviteFlowManager: any;
    localizationService: any;
    dispose(): void;
}

export class HistoryConsoleStore implements IHistoryConsoleStore {
    public historyConsoleController: HistoryConsoleController;
    public mainLayoutController: IMainLayoutController;
    public leftBarController: HistoryConsoleLeftBarController;
    public agentSettingsController: any;
    public inviteFlowManager: any;
    public localizationService: any;

    constructor(accountData: Record<string, any>, urlParams: IUrlParams, currentUser: any) {
        const rootStore = getRootStore();
        const {localizationService, appState} = rootStore;

        const dateFormat = get(accountData, 'protectedSettings.reportsDateFormat', DEFAULT_DATE_FORMAT);
        this.historyConsoleController = new HistoryConsoleController(
            dateFormat,
            rootStore.historyConsoleService,
            appState,
            rootStore.browserUtilsService,
            accountData,
            localizationService,
            rootStore.wifiAnalyzerApiService,
            currentUser?._id || '',
            rootStore.redirectionService
        );
        this.historyConsoleController.applyUrlParams(urlParams);

        const hasSearchCriteria = !!(
            urlParams.customerRef ||
            urlParams.customerPhone ||
            urlParams.customerEmail ||
            urlParams.roomId ||
            urlParams.scanId ||
            urlParams.startDate ||
            urlParams.endDate ||
            urlParams.preDataCollectionCode
        );
        if (appState.historyConsoleSessionsResults.length === 0 && hasSearchCriteria) {
            this.historyConsoleController.onSearch();
        }

        const generalSettings = {
            logoUrl: get(accountData, 'settings.logoUrl', '')
        } as GeneralSettings;

        this.mainLayoutController = new MainLayoutController(generalSettings);
        this.mainLayoutController.showLeftBar();

        appState.setAppUser(currentUser as IAppUser);
        appState.setAgentSettings(
            get(accountData, 'settings.passwordSettings', {}),
            generalSettings,
            get(accountData, 'settings.language', 'en-US')
        );

        this.agentSettingsController = rootStore.createAgentSettingsController();

        this.leftBarController = new HistoryConsoleLeftBarController(
            localizationService.translate,
            rootStore.environmentService,
            generalSettings,
            currentUser,
            null as any,
            null as any,
            rootStore.tsReactStateHelper
        );

        // Stub — AppLayoutComponent short-circuits on copilotSettings.enabled=false,
        // so initCopilot and accountId are never accessed
        this.inviteFlowManager = {copilotSettings: {enabled: false}};

        this.localizationService = localizationService;
    }

    dispose(): void {
        this.historyConsoleController.dispose();
    }
}
